export default "__VITE_ASSET__cc2f21e6__"